export default {
  check: "mdi-check",
  close: "mdi-close",
  close2: "mdi-close-circle",
  close3: "mdi-close-circle-outline",
  close4: "mdi-progress-close",
  clear: "mdi-backup-restore",
  save: "mdi-content-save",
  add: "mdi-plus-circle-outline",
  arrowLeft: "mdi-arrow-left",
  arrowRight: "mdi-arrow-right",
  arrowUp: "mdi-arrow-up",
  arrowDown: "mdi-arrow-down",
  trash: "mdi-trash-can",
  maximize: "mdi-window-maximize",
  minimize: "mdi-window-minimize",
  plus: "mdi-plus",
  search: "mdi-magnify",
  edit: "mdi-tooltip-edit",
  setting: "mdi-cog",
  tableEdit: "mdi-table-edit",
  variants: "mdi-filter-variant",
  delete: "mdi-trash-can-outline",
  detail: "mdi-file-edit-outline",
  detail2: "mdi-arrow-right-circle-outline",
  download: "mdi-file-download-outline",
  upload: "mdi-file-upload",
  attach: "mdi-paperclip",
  list: "mdi-format-list-bulleted-square",
  question: "mdi-help-circle",
  timer: "mdi-timer-sand",
  swap: "mdi-swap-horizontal",
  checkAll: "mdi-check-all",
  required: "mdi-asterisk",
  relation: "mdi-relation-many-to-many",
  send: "mdi-send",
  optimize: "mdi-cog-play-outline",
  result: "mdi-text-box-check-outline",
  progress: "mdi-progress-pencil",
  removedImage: "mdi-image-remove",
  export: "mdi-table-arrow-right",
  reset: "mdi-lock-reset",
  bookOutline: "mdi-book-check-outline",
  preview: "mdi-printer-eye",
  mdiChevronRight: "mdi-chevron-right",
  mdiChevronLeft: "mdi-chevron-left",
  mdiBarChart: "mdi-chart-bar",
  mdiTableLarge: "mdi-table-large",
};
